<template>
    <div style="background: #f2f2f2;">
        <common-head active="0" state="1" @search="search"></common-head>

        <!-- 搜索关键词 -->
        <div class="search">
            搜索产品：<input class="search-input" type="text" v-model="keyword">
            <button type="button" class="search-submit" @click="get_list">搜索</button>
        </div>

        <!-- 产品列表 -->
        <div class="list">
            <el-row :gutter="20">
                <el-col :span="8" v-for="(item,index) in list" :key="index">
                    <div class="list-item" @click="url('/product?id=' + item.id)">
                        <div class="item-image">
                            <el-image style="width: 450; height: 300px" :src="item.product_image"
                                fit="cover"></el-image>
                        </div>
                        <div class="item-name">
                            {{item.product_name}}
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>

        <common-footer></common-footer>
    </div>
</template>

<script>
    import commonHead from '@/components/pc/commonHead.vue';
    import commonFooter from '@/components/pc/commonFooter.vue';
    import { product_list } from '@/api/product.js';

    export default {
        name: 'product',
        components: {
            commonHead, commonFooter
        },
        data() {
            return {
                list: [],
                keyword: '',
            }
        },
        created() {
            this.keyword = this.$route.query.keyword;
            this.get_list();
        },
        metaInfo() {
            return {
                title: '搜索列表' + '-' + this.config.site.name,
                meta: [
                    { name: "keywords", content: "" },
                    { name: "description", content: "" },
                    { name: 'viewport', content: 'width=device-width, initial-scale=0, maximum-scale=0, user-scalable=yes,shrink-to-fit=no' }
                ],
            }
        },
        methods: {
            search(keyword) {
                this.keyword = keyword;
                this.get_list();
                const newUrl = this.$route.path + `?keyword=${keyword}`;
                window.history.replaceState('', '', newUrl);
            },

            get_list() {
                product_list({ 
                    count: 1000,
                    keyword:this.keyword,
                    loading:true,
                 }).then(res => {
                    if (res.code == 200) {
                        this.list = res.data.info;
                    }
                });
            },

            url(path) {
                if (path == '0') {
                    return false;
                }
                window.location.href = path;
            },

        },
    }
</script>
<style scoped>
    .list {
        width: 1300px;
        margin: 50px auto;
        text-align: left;
    }
    .list-item{
        border: 1px solid #eee;
        margin-bottom: 20px;
        background: #fff;
        text-align: center;
        border-radius: 5px;
        cursor: pointer;
    }
    .list-image{
        width: 450px;
        height: 300px;
    }
    .list-image img{
        width: 100%;
    }
    .list-item:hover{
       border: 1px solid #FF4F4F;
       box-shadow: 3px 3px 10px #FF4F4F;
    }
    .list-item:hover .item-name{
        background: linear-gradient(90deg, #FFECEC -1%, #FFFFFF -1%, #FF4E4E 100%);
    }
    .item-name{
        font-size: 18px;
        padding: 20px 0;
    }
    [class*=el-col-]{
        float: left;
    }
    .search{
        width: 1300px;
        margin: 0 auto;
        margin-top: 50px;
    }
    .search-input{
        width: 300px;
        height: 30px;
        border:1px solid #ccc;
        padding: 5px 15px;
    }
    .search-input:active {
        border:1px solid #aaa;
    }
    .search-submit{
        color: #fff;
        border: none;
        background-color: red;
        padding: 10px 20px;
        border-radius: 5px;
        margin-left: 20px;
        cursor: pointer;
    }
</style>